import { getOccupationDataSource } from './getOccupationDataSource';
import { getRoomSelectionData } from './getRoomSelectionData';
import { getRoomOccupationLabel } from '../../helpers';

export const getRoomDataSource = ({
  configDataSource = [],
  details = [],
  occupation = [],
  translate = () => {},
} = {}) => {
  return getRoomSelectionData({ details, occupation }).map(({ detail = {}, room, roomOccupation = {} }, index) => {
    const { image, items: [{ summary: plan = '' } = {}] = [], occupation: value = {}, rate = '', type = '' } = detail;
    const roomDataSource = getOccupationDataSource({
      configDataSource,
      occupation: roomOccupation ? [roomOccupation] : [],
    });

    return {
      image,
      id: room.id,
      index,
      room,
      occupation: getRoomOccupationLabel({
        adults: value.adults,
        children: value.children,
        dataSource: roomDataSource,
        translate,
      }),
      plan,
      rate: rate.replace(`${type}:`, '').trim(),
      title: type,
    };
  });
};
